export default class Config {
    constructor() {
        this._extraRequestThreshold = 256 * 1024;
    }
    extraRequestThreshold() {
        return this._extraRequestThreshold;
    }
    setExtraRequestThreshold(bytes) {
        if (bytes < 0) {
            throw new Error('extraRequestThreshold cannot be negative');
        }
        this._extraRequestThreshold = bytes;
    }
}
Config.global = new Config();
//# sourceMappingURL=Config.js.map